import { FEATURE_NAMES } from '../../loaders/features/features';
export const FEATURE_NAME = FEATURE_NAMES.genericEvents;
export const IDEAL_PAYLOAD_SIZE = 64000;
export const MAX_PAYLOAD_SIZE = 1000000;